<template>
    <BCard no-body>
      <BCardHeader class="pb-50"> <h5> {{ $t('Filters') }} </h5> </BCardHeader>
      <BCardBody>
          <!-- Filtro en desuso  -->
          <BRow>
            <BCol cols="12" md="4" class="mb-md-0 mb-2" >
              <label>Tipo</label>
              <vSelect v-model="typeFilter" label="name" :reduce="val => val.value" :options="typeOptions" class="invoice-filter-select" placeholder="Selecciona un tipo" > </vSelect>
            </BCol>

            <BCol cols="12" md="4" class="mb-md-0 mb-2" >
              <label>Estado</label>
              <vSelect v-model="statusFilter" label="name" :reduce="val => val.value" :options="statusOptions"  class="invoice-filter-select" placeholder="Selecciona un estado" > </vSelect>
            </BCol>

            
            <BCol v-if="paymentMethods" cols="12" md="4" class="mb-md-0 mb-2" >
              <label>Método de pago</label>
              <vSelect v-model="paymentMethodFilter" label="name" :reduce="val => val.id" :options="paymentMethods" class="invoice-filter-select" placeholder="Selecciona un método de pago" > </vSelect>
            </BCol> 
          </BRow>

          <BRow class="pt-2">
            <BCol v-if="groupsOptions && groupsOptions.length>1" cols="12" md="4" class="mb-md-0 mb-2" >
              <label>Sucursal</label>
              <vSelect v-model="groupFilter" label="name" :reduce="val => val.id" :options="groupsOptions" class="invoice-filter-select" placeholder="Selecciona una serie" > </vSelect>
            </BCol> 
            <DatepickerValidated vsMd="4" vsName="Start date" :vsModel.sync="startDateFilter" vsReset/>
            <DatepickerValidated vsMd="4" vsName="End date" :vsModel.sync="endDateFilter" :vsMin="startDateFilter ? startDateFilter: ''" vsReset/>
          </BRow>
      </BCardBody>
    </BCard>
  </template>
  
  <script>
  import { inject } from '@vue/composition-api'
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'

  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, DatepickerValidated },
    setup(){
      const statusFilter = inject('statusFilter')
      const statusOptions = inject('statusOptions')
      const typeFilter = inject('typeFilter')
      const typeOptions = inject('typeOptions')
      const paymentMethodFilter = inject('paymentMethodFilter')
      const paymentMethods = inject('paymentMethods')
      const groupFilter = inject('groupFilter')
      const groupsOptions = inject('groupsOptions')
      const startDateFilter = inject('startDateFilter')
      const endDateFilter = inject('endDateFilter')

      return {
        statusFilter,
        statusOptions,
        typeFilter,
        typeOptions,
        paymentMethodFilter,
        paymentMethods,
        groupsOptions, 
        groupFilter,
        startDateFilter,
        endDateFilter
      }
    }
  }
  </script>
  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
  